// imports section Start
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import no_image from "../../assets/images/no_image.png";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneIcon from "@mui/icons-material/Phone";
import { BASEURL } from "../../config/Config";

// imports section End

function GuestFooter() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPANYLOGO, ADDRESS, RESTNAME, USERNAME } =
    SYS_USER.USER_PARAM || {};

  const companyLogoUrl = COMPANYLOGO
    ? `${COMPANYLOGO.replace("~/", "")}`
    : null;

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        padding: "20px",
        boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
        mt: 4,
      }}
    >
      <CardContent>
        <Grid container spacing={4} alignItems="center">
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            display="flex"
            justifyContent="center"
          >
            {/* <CardMedia
              component="img"
              src={COMPANYLOGO || no_image}
              alt={RESTNAME || "Company Logo"}
              sx={{
                maxHeight: "140px",
                maxWidth: "140px",
                minHeight: "80px",
                minWidth: "80px",
                boxShadow: 2,
              }}
            /> */}

            <CardMedia
              component="img"
              src={companyLogoUrl || no_image}
              sx={{
                maxHeight: "140px",
                maxWidth: "140px",
                minHeight: "80px",
                minWidth: "80px",
                boxShadow: 2,

                // width: 280,
                // height: 280,
                p: 1,
                maxWidth: "240px",
                // mt: 2,
                // mb: 2,
                border: `3px solid ${theme.palette.background.paper}`,

                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.1)" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
            <Box borderBottom={1} pb={2} mb={2}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: theme.palette.text.primary }}
              >
                {RESTNAME}
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: theme.palette.text.secondary }}
              >
                {ADDRESS}
              </Typography>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              flexWrap="nowrap"
              flexDirection="column"
            >
              <Box display="flex" alignItems="center" gap={1} mb={2}>
                <MailOutlineIcon sx={{ color: theme.palette.primary.main }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {USERNAME}
                </Typography>
              </Box>

              {/* <Box display="flex" alignItems="center" gap={1} mb={2}>
                <LanguageIcon sx={{ color: theme.palette.primary.main }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  www.marriott.com
                </Typography>
              </Box>

              <Box display="flex" alignItems="center" gap={1} mb={2}>
                <PhoneIcon sx={{ color: theme.palette.primary.main }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  011 34 56 789
                </Typography>
              </Box> */}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Box>
  );
}

export default GuestFooter;
